const { ready } = require('./utilities');

const HIDDEN_CLASS = 'follow-upsell-modal--hidden';
const BODY_LOCK_CLASS = 'follow-upsell-modal__noscroll';

function isProSubscriber() {
  return document.body?.dataset?.userProSubscriber === 'true';
}

function getModal() {
  return document.querySelector('.js-follow-upsell-modal');
}

function setModalCopy(modal, { name, kind }) {
  const title = modal.querySelector('.js-follow-upsell-modal-title');
  const lead = modal.querySelector('.js-follow-upsell-modal-lead');
  if (!title || !lead) return;

  const label = name || (kind === 'stock' ? 'this stock' : 'this investor');
  title.textContent = `You're now following ${label}`;

  if (kind === 'stock') {
    lead.textContent =
      "We'll email you a monthly summary when big investors trade this stock. Pro members get alerts within minutes of each filing.";
  } else {
    lead.textContent =
      "We'll email you a monthly summary of new trades. Pro members get alerts within minutes of each filing.";
  }
}

function trackUpsellCtaClick(modal) {
  if (typeof gtag !== 'function') return;

  const kind = modal.dataset.upsellKind || 'guru';
  const eventName =
    kind === 'stock' ? 'stock_follow_upsell_pro_click' : 'guru_follow_upsell_pro_click';

  gtag('event', eventName, {
    event_category: 'follow_upsell',
    event_label: modal.dataset.upsellName || 'unlock-realtime-alerts-pro',
  });
}

function hideFollowUpsellModal() {
  const modal = getModal();
  if (!modal) return;

  modal.classList.add(HIDDEN_CLASS);
  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove(BODY_LOCK_CLASS);
}

function showFollowUpsellModal({ name, kind = 'guru' } = {}) {
  if (isProSubscriber()) return;

  const modal = getModal();
  if (!modal) return;

  setModalCopy(modal, { name, kind });
  modal.dataset.upsellKind = kind;
  if (name) {
    modal.dataset.upsellName = name;
  } else {
    delete modal.dataset.upsellName;
  }
  modal.classList.remove(HIDDEN_CLASS);
  modal.setAttribute('aria-hidden', 'false');
  document.body.classList.add(BODY_LOCK_CLASS);

  const closeButton = modal.querySelector('.follow-upsell-modal__close');
  closeButton?.focus();
}

function init() {
  const modal = getModal();
  if (!modal) return;

  modal.querySelectorAll('.js-follow-upsell-modal-close').forEach((el) => {
    el.addEventListener('click', hideFollowUpsellModal);
  });

  modal.querySelector('.follow-upsell-modal__cta')?.addEventListener('click', () => {
    trackUpsellCtaClick(modal);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.classList.contains(HIDDEN_CLASS)) {
      hideFollowUpsellModal();
    }
  });
}

ready(init);

if (typeof window !== 'undefined') {
  window.showFollowUpsellModal = showFollowUpsellModal;
}

module.exports = {
  showFollowUpsellModal,
  hideFollowUpsellModal,
  isProSubscriber,
};
